import React from 'react';
import DatasetManagementCard from "./DatasetManagementCard";
function DatasetManagementPage() {
    return <DatasetManagementCard />;
}

export default DatasetManagementPage;